import find from 'lodash/find'

// AccessBank-style products carry one "FUNERAL BENEFIT". DFCU splits the same
// cover by cause of death, and a claim carries whichever one applies, so the
// death benefit has to be matched against the whole set rather than one label.
const DEATH_BENEFIT_TYPES = [
  'FUNERAL BENEFIT',
  'Death_Natural',
  'Death_Accidental',
  'Death_PreExistingCondition'
]

export const findDeathBenefit = benefits => {
  if (!benefits) {
    return undefined
  }

  return find(benefits, function(benefit) {
    return benefit && DEATH_BENEFIT_TYPES.indexOf(benefit.type) !== -1
  })
}
